import { Attr, Model, BelongsTo, HasMany } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Recruiter from "./Recruiter";
import Application from "./Application";
import { UploadFile } from "./types";

@Model()
class Candidate extends ApplicationRecord {
  static jsonapiType = "candidates";

  @Attr() additionalInfo: string;

  @Attr() contactNumber: string;

  @Attr() currentEmployer: string;

  @Attr() currentJobTitle: string;

  @Attr() currentSalary: number;

  @Attr() cv: UploadFile;

  @Attr() cvData: string;

  @Attr() desiredSalary: number;

  @Attr() editCandidateLink: string;

  @Attr() email: string;

  @Attr() firstName: string;

  @Attr() gender: string;

  @Attr() hasDrivingLicence: boolean;

  @Attr() jobType: string;

  @Attr() lastName: string;

  @Attr() location: string;

  @Attr() nationality: string;

  @Attr() recruiterId: number;

  @Attr() recruiterUserId: number;

  @Attr() submitToJobLink: string;

  @Attr({ persist: false }) createdAt: Date;

  @Attr({ persist: false }) updatedAt: Date;

  @Attr() viewCandidateLink: string;

  @Attr() viewCvLink: string;

  @Attr() noticePeriod: string;

  @BelongsTo(Recruiter) recruiter: Recruiter;

  @HasMany(Application) applications: Application[];

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
}

export default Candidate;
